import { useMutation } from '@tanstack/react-query';
import {
  cancelOffboarding,
  invalidateOffboardings,
} from '../../services/offboardings';
import { invalidateMarketingData } from '../../services/marketing';
import { OffboardingMutationResult } from '../../types/offboardings';

function useCancelOffboarding(
  options: {
    onMutate?: () => void;
    onSuccess?: (result: OffboardingMutationResult) => void;
    onError?: (error: unknown) => void;
    onSettled?: () => void;
  } = {},
) {
  return useMutation({
    mutationFn: (offboardingId: string) => cancelOffboarding(offboardingId),
    onMutate: options.onMutate,
    onSuccess: async result => {
      await invalidateOffboardings(result.businessId, result.id);
      if (result.hadLinkedCampaign) {
        await invalidateMarketingData();
      }
      options.onSuccess?.(result);
    },
    onError: options.onError,
    onSettled: options.onSettled,
  });
}

export default useCancelOffboarding;
